import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

//				sx={{ clipPath: 'polygon( 0 0, 100% 0%, 100% 75%, 0 100%)', backgroundColor: '#d602ee' }}

export default function GetResult() {
	const navigate = useNavigate();
	const [ codeValue, setCodeValue ] = React.useState('');
	const [ isGetResultEnabled, setIsGetResultEnabled ] = React.useState(false);

	const handleCodeChange = 
		( a_event: React.ChangeEvent<HTMLInputElement> ) => {
			const value = a_event.target.value;
			setCodeValue( value );
			setIsGetResultEnabled( value.length >= 10 ); // TODO: real md5 sum
			
			// todo: enter ütésre is
		};
	    
	const handleGetResultClick = () => {
		navigate(`/result/${codeValue}`);
		//const newPageUrl = `${window.location.origin}/result/report.html#${codeValue}`;
		//window.open( newPageUrl, '_blank' );
	};

	return (
		<Box
			display='flex'
			flexDirection='column'
			flex='1'
			alignItems='center'
			justifyContent='center'
		>
			<Box
				display='flex'
				flexDirection='column'
				flex='1'
				alignItems='center'
				justifyContent='center'
				alignSelf='stretch'
				height='40em'
				sx={{ clipPath: 'polygon( 0 0, 100% 0%, 100% 75%, 0 100%)', backgroundImage: `url( 'fipok_logo_bg_web.svg' )`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
			>
				<Box
					margin='auto'
					display='flex'
					flexDirection='column'
					padding='1.5em'
					sx={{ borderBottomLeftRadius: '5em', backgroundColor: 'white' }}
				>
					<Box
						fontSize='5em'
						fontWeight='500'
						color='black'
					>
						Get your results
					</Box>
					<Box
						display='flex'
						justifySelf='stretch'
						padding='3em'
						justifyContent='flex-end'
						marginTop='1em'		
					>
						<Box
							display='flex'
							alignItems='center'
						>
							<TextField
								id='tf-code'
								label='Code'
								variant='outlined'
								value={ codeValue } onChange={ handleCodeChange }
							/>
							<Button
								variant="contained"
								disabled={ !isGetResultEnabled } onClick={ handleGetResultClick }
								sx={{ marginLeft: '1em', alignSelf: 'stretch' }}
							>
								Get Report
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
			<Box
				flex='1'
			>
			</Box>
		</Box>
	);
};
